<template>
  <div id="Cardinfo">
    <div class="botmbgd"></div>
    <div class="cardinfo">
      <a-card class="box-card" :bordered="false" style="width: 300px;">
        <img  v-if="this.hasTeacherVersion == 0" class="teaTag" src="../../assets/tea_nor.png" >
        <img v-if="this.hasTeacherVersion == 1" class="teaTag" src="../../assets/tea_pro.png">
        <p>
          <img src="../../assets/name.png" class="cardinfoIcon">
          用户姓名：{{name}}
          <button class="login-out" @click="loginOut">退出账号</button>
        </p>
        <p>
          <img src="../../assets/school.png" class="cardinfoIcon">
          所属单位：{{university}}
        </p>
        <p v-if="id">
          <img src="../../assets/xuehao.png" class="cardinfoIcon">
          用户编号：{{id}}
        </p>
        <!-- <p v-if="traintime">
          <a-icon class="icon" type="clock-circle" />
          训练时间：{{traintime}}
        </p> -->
      </a-card>
    </div>
  </div>
</template>

<script>
import Axios from "@/Axios";
import infoAction from "@/utils";
export default {
  name: "Cardinfo",
  data() {
    return {
      hasTeacherVersion: infoAction.getinfo("TeacherVersion"),
      name: infoAction.getinfo("teacher_info").name,
      university: infoAction.getinfo("universityId_dictText", false),
      // traintime: infoAction("userinfo").password,
      id: infoAction.getinfo("teacher_info").id,
    };
  },
  mounted() {},
  methods: {
    loginOut() {
      this.$emit('loginOut')
    }
  },
};
</script>
<style scoped>
.teaTag{
    height: 2em;
    float: right;
    margin-right: -5px;
    margin-top: -15px;
}
@media screen and (min-width: 768px) {
.teaTag{
    height: 46px;
    float: right;
    margin-right: 7px;
    margin-top: -2px;
}
}
.botmbgd {
  width: 100%;
  height: 120px;
  background: #0D88FA;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
  position: absolute;
}
.login-out {
  margin-left: 20px;
  border: none;
  outline: none;
  background: #0D88FA;
  color: #ffffff;
  border-radius: 20px;
  padding: 0px 10px;
  font-size: 14px;
}
@media screen and (max-width: 768px) {
.cardinfoIcon {
  margin-right: 5px;
  margin-top: -5px;
  width: 18px;
  height: auto;
}
}
@media screen and (min-width: 768px) {
  .cardinfoIcon {
    width: 30px;
    height: auto;
    margin-right: 5px;
}
}
.cardinfo {
  width: 103%;
  margin-left: -6px;
  box-sizing: border-box;
  padding: 2vh;
  margin-top: 1vh;
  text-align: left;
  /* border: 1px dashed black; */
  margin-bottom: 3vh;
}
.cardinfo .box-card {
  box-sizing: border-box;
  padding-left: 1vw;
  line-height: 30px;
  width: 100% !important;
  border-radius: 1vw;
  background: url('../../assets/bg@2x.png') no-repeat center center;
  background-size: 100% 100%;
  color: #000;
  position: relative;
  /* top: -110px; */
}
.box-card >>> .ant-card-body {
  padding: 38px 17px 50px;
}
@media screen and (min-width: 768px) {
.box-card {
  height: 300px;
  font-size: 25px;
}
}
@media screen and (min-width: 768px) {
.box-card  p {
  margin-top: 30px;
  margin-bottom: 20px;
  font-size: 23px;
  color: #333333;
  font-weight: bold;
}
}
@media screen and (max-width: 768px) {
.box-card p {
  margin-bottom: 0.5em;
  font-weight: bold;
  color: #333333;
}
}
@media screen and (max-width: 768px) {
  .cardinfo {
    box-sizing: border-box;
    padding: 1vh;
    margin-top: 1vh;
    text-align: left;
    width: 102vw;
    margin-left: -3px;
    margin-bottom: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Cardinfo/Cardinfotwo.vue